import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import { ApiResponse } from "../../types/api.types";
import { FORM30_ENDPOINTS } from "./endpoints";

export interface Form30Data {
    sector_id: string;
    year: number;
    data: Record<string, Record<string, Record<string, number | null>>>;
}

export interface Form30Response {
    success: boolean;
    message?: string;
    data?: Form30Data & {
        _id: string;
        createdAt: string;
        updatedAt: string;
    };
    error?: string;
}

/**
 * Сохранить данные формы 30
 */
export const saveForm30 = async (
    sector_id: string,
    year: number,
    data: Record<string, Record<string, Record<string, number | null>>>
): Promise<Form30Response> => {
    const response = await fetchData(FORM30_ENDPOINTS.SAVE, {
        method: "POST",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ sector_id, year, data })
    }, 2);

    return response.json();
};

/**
 * Получить данные формы 30
 */
export const getForm30 = async (
    sector_id: string,
    year: number
): Promise<Form30Response> => {
    const url = `${FORM30_ENDPOINTS.FETCH}?sector_id=${sector_id}&year=${year}`;
    
    const response = await fetchData(url, {
        method: "GET",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};

/**
 * Удалить данные формы 30
 */
export const deleteForm30 = async (
    sector_id: string,
    year: number
): Promise<Form30Response> => {
    const url = `${FORM30_ENDPOINTS.DELETE}?sector_id=${sector_id}&year=${year}`;
    
    const response = await fetchData(url, {
        method: "DELETE",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};

export interface Form30DashboardItem {
    sector_id: string;
    value: number | null;
}

export interface Form30DashboardResponse {
    success: boolean;
    data: Form30DashboardItem[];
    message?: string;
    error?: string;
}

/**
 * Получить данные для дашборда - конкретный показатель по всем регионам
 */
export const getForm30Dashboard = async (
    year: number,
    table_id: string,
    row_id: string,
    column_key: string
): Promise<Form30DashboardResponse> => {
    const url = `${FORM30_ENDPOINTS.DASHBOARD}?year=${year}&table_id=${table_id}&row_id=${row_id}&column_key=${column_key}`;
    
    const response = await fetchData(url, {
        method: "GET",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};
